import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import { withRouter, Link } from "react-router-dom";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Breadcrumb from "../../components/Breadcrumb";
import Loading from "../../components/loadingSpinner/Loading";
import AdminDateFilter from "../../components/admin/AdminDateFilter";
import AdminStatCard from "../../components/admin/AdminStatCard";
import { Grid, Paper, Typography, Button, Table, TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import moment from "moment";

@inject("adminStore")
@withRouter
@observer
class AdminActs extends Component {
    breadcrumb = [
        { name: "Admin Dashboard", link: "/admin" },
        { name: "Acts & Artists" }
    ];
    
    state = {
        isLoading: true,
        startDate: moment().startOf("month"),
        endDate: moment().endOf("month")
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { startDate, endDate } = this.state;
        this.setState({ isLoading: true });
        
        this.props.adminStore.getActsStats(
            startDate.format("YYYY-MM-DD"),
            endDate.format("YYYY-MM-DD")
        ).then(() => {
            this.setState({ isLoading: false });
        }).catch(() => {
            this.setState({ isLoading: false });
        });
    };

    handleDateChange = (startDate, endDate) => {
        this.setState({ startDate, endDate }, this.loadData);
    };

    render() {
        const { isLoading } = this.state;
        const { actsStats } = this.props.adminStore;

        return (
            <Fragment>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Breadcrumb links={this.breadcrumb} />
                    <Fragment>
                        <Paper style={{ padding: 16, marginBottom: 16 }}>
                            <Grid container spacing={16} alignItems="center">
                                <Grid item>
                                    <Button
                                        component={Link}
                                        to="/admin"
                                        size="small"
                                        style={{ marginRight: 16 }}
                                    >
                                        <ArrowBackIcon style={{ marginRight: 4 }} />
                                        Back to Overview
                                    </Button>
                                </Grid>
                                <Grid item xs>
                                    <Typography variant="h5" style={{ color: "#262626", fontWeight: 600 }}>
                                        Acts & Artists
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <AdminDateFilter onDateChange={this.handleDateChange} />
                                </Grid>
                            </Grid>
                        </Paper>

                        <Loading showed={isLoading} />

                        <Typography variant="subtitle1" style={{ marginBottom: 8, fontWeight: 600, color: "#666" }}>
                            Artists
                        </Typography>
                        <Grid container spacing={16} style={{ marginBottom: 24 }}>
                            <Grid item xs={12} sm={4}>
                                <AdminStatCard
                                    title="Total Artists"
                                    total={actsStats.totalArtists}
                                    newCount={actsStats.newArtists}
                                    color="#ff0c9c"
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <AdminStatCard
                                    title="New Artists"
                                    total={actsStats.newArtists}
                                    newCount={actsStats.newArtists}
                                    newLabel="in selected period"
                                    color="#4caf50"
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <AdminStatCard
                                    title="Existing Artists"
                                    total={actsStats.existingArtists}
                                    newCount={0}
                                    newLabel="before this period"
                                    color="#2196f3"
                                />
                            </Grid>
                        </Grid>

                        <Typography variant="subtitle1" style={{ marginBottom: 8, fontWeight: 600, color: "#666" }}>
                            Acts
                        </Typography>
                        <Grid container spacing={16} style={{ marginBottom: 24 }}>
                            <Grid item xs={12} sm={4}>
                                <AdminStatCard
                                    title="Total Acts"
                                    total={actsStats.totalActs}
                                    newCount={actsStats.newActs}
                                    color="#9c27b0"
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <AdminStatCard
                                    title="New Acts"
                                    total={actsStats.newActs}
                                    newCount={actsStats.newActs}
                                    newLabel="in selected period"
                                    color="#4caf50"
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <AdminStatCard
                                    title="Existing Acts"
                                    total={actsStats.existingActs}
                                    newCount={0}
                                    newLabel="before this period"
                                    color="#2196f3"
                                />
                            </Grid>
                        </Grid>

                        {actsStats.recentArtists && actsStats.recentArtists.length > 0 && (
                            <Paper style={{ padding: 16 }}>
                                <Typography variant="subtitle1" style={{ marginBottom: 16, fontWeight: 600 }}>
                                    Recent New Artists
                                </Typography>
                                <Table>
                                    <TableHead>
                                        <TableRow style={{ backgroundColor: "#ff0c9c" }}>
                                            <TableCell style={{ color: "#fff" }}>Name</TableCell>
                                            <TableCell style={{ color: "#fff" }}>Email</TableCell>
                                            <TableCell style={{ color: "#fff" }}>Created Date</TableCell>
                                            <TableCell style={{ color: "#fff" }}>Status</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {actsStats.recentArtists.map((artist, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{artist.name}</TableCell>
                                                <TableCell>{artist.email}</TableCell>
                                                <TableCell>{moment(artist.createdAt).format("DD MMM YYYY")}</TableCell>
                                                <TableCell>{artist.status}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Paper>
                        )}
                    </Fragment>
                </MainContainer>
            </Fragment>
        );
    }
}

export default AdminActs;
